export const downloadCsv = (url: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = <string>url.split('/').pop();
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
